import { FC, ReactNode, useState } from "react"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { PageTitle, useIntl, Button, Tooltip } from "@metsooutotec/modes-react-components"
import ListView from "components/utils/list-view/list-view"
import usersStore from "features/users/store/users-store"
import { WSUser } from "features/users/models/users-models"
import WSUserModal from "features/users/components/user-modal/user-modal"
import styles from "./users-page.module.css"

const UsersPage: FC = observer(() => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { users, loadAllUsersAsync } = usersStore
    const [isModalOpen, setIsModalOpen] = useState(false)

    const template = [
        {
            headingKey: "userTableHeadings.userDisplayName",
            cellFunc: (c: WSUser) => c.displayName,
            isSearchable: true,
        },
        {
            headingKey: "userTableHeadings.userEmail",
            cellFunc: (c: WSUser) => c.email,
            isSearchable: true,
        },
        {
            headingKey: "userTableHeadings.jobTitle",
            cellFunc: (c: WSUser) => c.jobTitle,
            isSearchable: true,
        },
    ]

    const userModal = {
        open: () => {
            setIsModalOpen(true)
        },
        close: () => {},
    }

    const rightPageButtons: ReactNode = (
        <>
            <Button icon='icon-plus-16' labelPosition='right' primary onClick={userModal.open}>
                {formatMessage("users.createButton")}
            </Button>
        </>
    )

    const subTitle: ReactNode = (
        <span>
            {formatMessage("users.numberOfUsers")}: {users.length}
            <Tooltip
                content={formatMessage("users.reloadUsers")}
                data-cy='tooltip'
                position='top center'
                small
                trigger={
                    <Button
                        icon='icon-reload-16'
                        labelPosition='right'
                        onClick={() => {
                            loadAllUsersAsync()
                        }}
                        subtle
                    />
                }
            />
        </span>
    )
    return (
        <>
            <PageTitle title={formatMessage("users.pageTitle")} extraItems={rightPageButtons} subTitle={subTitle} />

            <div className={styles.userTable}>
                <ListView
                    key={"usersTable"}
                    noneYetKey='users.noUsers'
                    template={template}
                    data={users?.slice().sort((a, b) => a?.displayName?.localeCompare(b?.displayName))}
                    onClickRow={(c: WSUser) => navigate("/users-management/" + c.id)}
                />
            </div>
            {isModalOpen && <WSUserModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />}
        </>
    )
})

export default UsersPage
